// Config
import axiosAdminRequestConfig from './axiosAdmin';

// Service
import BaseService from './service';

class AdminService extends BaseService {
  constructor() {
    super(axiosAdminRequestConfig);
  }
}

export default AdminService;
